import { render, staticRenderFns } from "./Empty.vue?vue&type=template&id=15bf8210&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/data/app_data/product_data/deploy-center/s3-deploy/uqp/embedded.profile.acgn/v1.1.2-20210730-175657/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlideXReverseTransition } from 'vuetify/lib'
installComponents(component, {VSlideXReverseTransition})
